/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetClientFullBodyQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetClientFullBodyQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    businessLine: Types.BusinessLine;
    id: string;
    photoFullBody?: {
      __typename?: "ClientPhoto";
      id: string;
      image: {
        __typename?: "Image";
        baseUrl: string;
        mediaPath: string;
        altText: string;
        width?: number | null;
        height?: number | null;
      };
    } | null;
  } | null;
};

export const GetClientFullBodyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getClientFullBody" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "client" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "businessLine" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "photoFullBody" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                            { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
                            { kind: "Field", name: { kind: "Name", value: "altText" } },
                            { kind: "Field", name: { kind: "Name", value: "width" } },
                            { kind: "Field", name: { kind: "Name", value: "height" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetClientFullBodyQuery__
 *
 * To run a query within a React component, call `useGetClientFullBodyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientFullBodyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientFullBodyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientFullBodyQuery(
  baseOptions?: Apollo.QueryHookOptions<GetClientFullBodyQuery, GetClientFullBodyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetClientFullBodyQuery, GetClientFullBodyQueryVariables>(
    GetClientFullBodyDocument,
    options,
  );
}
export function useGetClientFullBodyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientFullBodyQuery,
    GetClientFullBodyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetClientFullBodyQuery, GetClientFullBodyQueryVariables>(
    GetClientFullBodyDocument,
    options,
  );
}
// @ts-ignore
export function useGetClientFullBodySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetClientFullBodyQuery,
    GetClientFullBodyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetClientFullBodyQuery, GetClientFullBodyQueryVariables>;
export function useGetClientFullBodySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetClientFullBodyQuery, GetClientFullBodyQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetClientFullBodyQuery | undefined,
  GetClientFullBodyQueryVariables
>;
export function useGetClientFullBodySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetClientFullBodyQuery, GetClientFullBodyQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetClientFullBodyQuery, GetClientFullBodyQueryVariables>(
    GetClientFullBodyDocument,
    options,
  );
}
export type GetClientFullBodyQueryHookResult = ReturnType<typeof useGetClientFullBodyQuery>;
export type GetClientFullBodyLazyQueryHookResult = ReturnType<typeof useGetClientFullBodyLazyQuery>;
export type GetClientFullBodySuspenseQueryHookResult = ReturnType<
  typeof useGetClientFullBodySuspenseQuery
>;
export type GetClientFullBodyQueryResult = Apollo.QueryResult<
  GetClientFullBodyQuery,
  GetClientFullBodyQueryVariables
>;
